
/* eslint-disable */
import * as conditioner from 'conditioner-core/conditioner-core.min';

const appjs = document.getElementById('appjs');
const ParamsData = {};
for (let key in appjs.dataset) {
    ParamsData[key] = appjs.dataset[key];
}

export { ParamsData };

// print css
const link = document.createElement('link');
link.rel = 'stylesheet';
link.media = 'print';
link.href = `${ParamsData.wp_theme_url}/assets/print.css`;
document.head.appendChild(link);

// OneTrust Cookies Consent
ParamsData.oneTrust_id && import('./modules/onetrust').then(module => module.Onetrust());

// MarkerIo bugReports
ParamsData.bug_report_id && import('./modules/markerIo').then(module => module.bugReport());

// Conditioner
conditioner.addPlugin({
    // the plugin "monitor" hook
    // use in html : <div data-module="modules/component.js" data-context="@visible true"></div>
    monitor: {
        // the name of our monitor, not prefixed with "@"
        name: 'visible',

        // the monitor factory method, this will create our monitor
        create: (context, element) => ({
            // current match state
            matches: false,

            // called by conditioner to start listening for changes
            addListener(change) {
                new IntersectionObserver((entries) => {
                    // update the matches state
                    this.matches = entries.pop().isIntersecting === context;

                    // inform conditioner of the new state
                    change();
                }).observe(element);
            },
        }),
    },

    // converts module aliases to paths
    moduleSetName: (name) => `./${name}.js`,

    // get the module constructor
    moduleGetConstructor: (module) => module.default,

    // override the import (this makes webpack bundle all the dynamically included files as well)
    // https://webpack.js.org/api/module-methods/#import-
    // - set to "eager" to create a single chunk for all modules
    // - set to "lazy" to create a separate chunk for each module
    moduleImport: (name) => import(/* webpackMode: "lazy" */ `${name}`),
});

conditioner.hydrate(document.documentElement);



/**
 * app
 * 
 */

import Lenis from "./modules/lenis";
import { gsap } from "./modules/gsap";
import { ScrollTrigger, ScrollSmoother } from "./modules/ScrollTrigger";
import { BlurScrollEffect as BlurScrollEffect1 } from './modules/blurScrollEffect.js';
import { TextSplitter } from './modules/textSplitter.js';

history.scrollRestoration = 'manual';
window.scrollTo(0, 0);


const lenis = new Lenis({
    lerp: 0.14,
    wheelMultiplier: 1
});
lenis.on('scroll', ScrollTrigger.update());
gsap.ticker.add(time => lenis.raf(time * 1000));

gsap.ticker.lagSmoothing(0);

export { lenis };

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

lenis.scrollTo(0, { immediate: true });


const homepage = () => {
    lenis.scrollTo(0, { immediate: true });
    document.body.classList.add("show");
    const hr_under = document.querySelector("hr.under_header-bg")
    const spline_viewer = document.querySelector("spline-viewer")

    let ismobile = window.innerWidth < 992 ? true : false;

    function animation(onend) {
        const header = document.querySelector("#header");
        const plus = header.querySelector(".plus");
        plus.classList.add('anim');

        setTimeout(() => {
            plus.classList.add('small');
        }, 800)

        setTimeout(() => {
            plus.classList.add('rotate');
            header.classList.add('anim');
        }, 1100)

        setTimeout(() => {
            header.classList.add('display');
            onend()
        }, 1500)
    }

    function strate_intro() {
        const strate = document.querySelector(".strate-intro");

        if (!strate) return;

        const h1 = strate.querySelector("h1");
        const splitter = new TextSplitter(h1, {
            resizeCallback: () => { },
            splitTypeTypes: 'lines, words'
        });

        const words = splitter.getWords();
        gsap.set(words, {
            translate: `0 145%`,
        });

        this.start = () => {
            gsap.fromTo(words, {
                translate: `0 145%`,
            }, {
                ease: "power3.out",
                translate: `0 0`,
                stagger: 0.08,
            });
            strate.classList.add('show');
            spline_viewer.classList.add('show');
        }
    }

    function strate_pillars() {
        const strate = document.querySelector(".strate-pillars");

        if (!strate) return;

        const content = strate.querySelector(".strate-content");
        const sticky = strate.querySelector(".sticky");

        gsap.timeline({
            scrollTrigger: {
                trigger: strate,
                start: 'top top',
                end: 'bottom bottom',
                scrub: true,
                onUpdate: (self) => {
                    if (ismobile) return;
                    const val = self.progress.toFixed(3);
                    content.style.gap = `${10 - val * 10}rem`;
                    content.style.translate = `0 ${20 - (val * 20)}rem`;
                    //  console.log(sticky.offsetHeight - window.innerHeight);
                    // strate.style.marginBottom = `${(  sticky.offsetHeight - window.innerHeight)}px`;
                },
            }
        });
    }

    function strate_brands() {
        const header = document.querySelector(".strate-brands-header");
        const strate = document.querySelector(".strate-brands");

        ScrollTrigger.create({
            trigger: header,
            start: 'top top',
            end: 'bottom bottom',
            onEnter: () => hr_under.classList.add("show"),
            onEnterBack: () => hr_under.classList.remove("show"),
        });


        if (!strate) return;

        const items = strate.querySelectorAll(".teaser");
        const videos = strate.querySelectorAll("video");
        const sticky = strate.querySelector(".sticky");
        let slide = 0;
        let oldslide = 0;

        if (ismobile) {
            videos.forEach(video => {
                video.querySelector('source').src = video.dataset.mobile
                video.controls = false;
                video.autoplay = true;
            })
        }
        //  if (ismobile) return;
        /*  
                3 vid
                 if (self.progress > 0.33) {
                        slide = 1;
                    }
                    if (self.progress > 0.66) {
                        slide = 2;
                    }
         */
        let disable = false;

        ScrollTrigger.create({
            trigger: strate,
            start: 'top top+=10',
            end: 'bottom bottom-=10',
            onUpdate: (self) => {
                slide = 0;

                if (self.progress > 0.25) {
                    slide = 1;
                }
                if (self.progress > 0.5) {
                    slide = 2;
                }
                if (self.progress > 0.75) {
                    slide = 3;
                }

                if (oldslide != slide) {
                    strate.style.setProperty("--dir", self.direction);
                    lenis.stop();
                    setTimeout(() => lenis.start(), 600)
                    items.forEach((item, i) => {
                        if (slide < i) {
                            item.classList.remove("in");
                            item.classList.remove("after");
                            item.classList.add("before");
                        } else if (slide == i) {
                            item.classList.add("in");
                            item.classList.remove("after");
                            item.classList.remove("before");
                        } else {
                            item.classList.remove("in");
                            item.classList.remove("before");
                            item.classList.add("after");
                        }
                    });
                }

                oldslide = slide;
            },
        });
        if (!ismobile) {
            gsap.fromTo(items[0].querySelector(".videos"), {
                y: "-30rem",
            }, {
                y: "0",
                scrollTrigger: {
                    trigger: sticky,
                    start: 'top bottom',
                    end: 'bottom bottom',
                    scrub: true,
                },
            });

            const hubs = document.querySelector(".strate-hubs");
            gsap.fromTo(items[3].querySelector(".videos"), {
                y: "0rem",
            }, {
                y: "30rem",
                scrollTrigger: {
                    trigger: hubs,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true,
                },
            });
        }
        ScrollTrigger.create({
            trigger: strate,
            start: 'top bottom',
            end: 'bottom top',
            onToggle: (self) => {
                if (self.isActive) {
                    videos.forEach(video => video.play());
                } else {
                    videos.forEach(video => video.pause());
                }
            }
        });
        ScrollTrigger.create({
            trigger: strate,
            start: 'top top',
            end: 'bottom bottom',
            onToggle: (self) => {
                lenis.stop();
                setTimeout(() => lenis.start(), 1)
            }
        });
    }

    function strate_hubs() {
        const strate = document.querySelector(".strate-hubs");

        if (!strate) return;

        if (!ismobile) {
            const agencies = strate.querySelectorAll(".agencies");
            const items = strate.querySelectorAll(".card");
            gsap.to(items, {
                ease: 'none',
                translate: "0",
                stagger: .5,
                scrollTrigger: {
                    trigger: agencies,
                    start: 'top bottom',
                    end: 'bottom center',
                    scrub: true,
                },
            });
        } else {
            const agencies = strate.querySelector(".agencies");
            ScrollTrigger.create({
                trigger: strate,
                start: 'top top',
                end: 'bottom bottom',
                scrub: 1,
                onUpdate: (self) => {
                    const width = agencies.clientWidth - window.innerWidth - 32;
                    agencies.style.translate = `calc(-${self.progress * width}px)`;
                }
            });
        }
    }

    function strate_book() {
        const strate = document.querySelector(".strate-book");
        const citation = strate.querySelector(".citation");
        const strate_content = strate.querySelector(".strate-content");

        if (ismobile) return;

        ScrollTrigger.create({
            trigger: strate_content,
            start: 'top bottom',
            end: 'bottom bottom',
            scrub: true,
            onUpdate: (self) => {
                citation.style.translate = `0 ${-self.progress * 200}px`;
                citation.style.opacity = 1 - self.progress;
            }
        });
    }

    const intro = new strate_intro();

    strate_pillars();
    strate_brands();
    strate_hubs();
    strate_book();

    animation(() => intro.start());

    document.querySelectorAll(".blur-text").forEach(el => new BlurScrollEffect1(el, 1));
    document.querySelectorAll(".blur-text-1").forEach(el => new BlurScrollEffect1(el, 2));

    const body = document.body;
    let timer;

    window.addEventListener('scroll', function () {
        clearTimeout(timer);
        if (!body.classList.contains('disable-hover')) {
            body.classList.add('disable-hover')
        }

        timer = setTimeout(function () {
            body.classList.remove('disable-hover')
        }, 150);
    }, false);
}

const page = () => {
    document.body.classList.add("show");
    const header = document.querySelector("#header");
    const plus = header.querySelector(".plus");

    plus.classList.add('anim');
    plus.classList.add('small');
    plus.classList.add('rotate');
    header.classList.add('anim');
    header.classList.add('display');
}

if (document.querySelector(".homepage")) {
    document.fonts.ready.then(() => homepage());
} else {
    document.fonts.ready.then(() => page());
}
